import { Trans } from "@lingui/react/macro";

import CashIcon from "@/assets/icons/cash-icon.svg?react";
import HandleIcon from "@/assets/icons/handle-icon.svg?react";
import Logo from "@/assets/icons/logo.svg?react";
import fancyRestaurant from "@/assets/images/fancy-house.jpg";
import emptyGazeboGarden from "@/assets/images/peace-mind.jpg";

export default function ListingBenefits() {
  return (
    <section>
      <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <h3 className="title-desktop-titlerg max-w-[580px]">
          <Trans>
            From Listings to Guests, <span className="font-semibold">We've Got You Covered</span>
          </Trans>
        </h3>
      </div>
      <div className="mt-8 flex flex-col gap-8 lg:mt-12 lg:flex-row lg:items-end lg:gap-5">
        <div className="flex flex-col gap-8">
          <Logo className="hidden size-16 md:block" />

          <div className="bg-primary flex flex-col rounded-3xl p-4 text-(--color-text-color-text-beige) md:rounded-4xl md:p-5 lg:min-h-[340px]">
            <CashIcon className="mb-4 size-12" />
            <h4 className="title-desktop-subtitlesb mt-auto mb-2.5">
              <Trans>Maximise your income</Trans>
            </h4>
            <p className="font-medium">
              <Trans>
                Unlock the potential to boost your rental income by up to 40% without lifting a
                finger.
              </Trans>
            </p>
          </div>
        </div>
        <div>
          <div className="mb-6 rounded-3xl bg-(--color-bg-color-bg-dark-beige) p-4 md:mb-8 md:rounded-4xl md:p-5">
            <h4 className="mb-6 text-xl font-semibold md:mb-8 md:text-3xl">
              <Trans>Enjoy peace of mind knowing your property is in expert hands</Trans>
            </h4>
            <img
              src={emptyGazeboGarden}
              alt="Empty Gazebo Garden"
              width="900"
              height="500"
              loading="lazy"
              className="aspect-900/500 max-h-[500px] w-full rounded-2xl"
            />
          </div>
          <p className="font-medium lg:px-6">
            <Trans>
              With deep expertise in facility management, we help homeowners maximize rental income
              stress-free. From maintenance to guest care, our team handles it all — making us
              Egypt's Top choice for property management.
            </Trans>
          </p>
        </div>
        <div>
          <div className="mb-8 rounded-3xl bg-(--color-bg-color-bg-lime) p-4 md:rounded-4xl md:p-5">
            <HandleIcon className="mb-11 size-12" />
            <h4 className="title-desktop-subtitlesb mb-2.5">
              <Trans>We handle it all</Trans>
            </h4>
            <p className="font-medium">
              <Trans>
                From listing to cleaning and everything in between we provide a hassle-free property
                management experience
              </Trans>
            </p>
          </div>
          <img
            src={fancyRestaurant}
            alt="Fancy Restaurant"
            width="500"
            height="500"
            className="max-h-[500px] w-full rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
}
